import type { PublishedChangeReview } from "../../../shared/publishedChangeReview";

export function pullRequestDescription(review: PublishedChangeReview) {
  if (review.status !== "complete") return "";
  return [
    review.summary,
    ...review.changes.map((change) => `- ${change.title}: ${change.after}`),
  ]
    .filter(Boolean)
    .join("\n\n");
}

export function createPullRequestUrl(
  remoteUrl: string,
  gitBranchName: string,
  description = ""
) {
  let base: URL;
  try {
    base = new URL(remoteUrl.replace(/\/+$/, "").replace(/\.git$/, ""));
  } catch {
    return null;
  }
  const isGitlab = base.hostname.includes("gitlab");
  const url = new URL(
    isGitlab
      ? `${base}/-/merge_requests/new`
      : `${base}/compare/${gitBranchName.split("/").map(encodeURIComponent).join("/")}`
  );
  if (isGitlab) {
    url.searchParams.set("merge_request[source_branch]", gitBranchName);
  } else {
    url.searchParams.set("expand", "1");
  }
  const descriptionKey = isGitlab ? "merge_request[description]" : "body";
  const paragraphs = description ? description.split("\n\n") : [];
  while (paragraphs.length > 0) {
    url.searchParams.set(descriptionKey, paragraphs.join("\n\n"));
    if (url.href.length <= 8_000) break;
    paragraphs.pop();
  }
  if (paragraphs.length === 0) url.searchParams.delete(descriptionKey);
  return { href: url.href, isGitlab };
}
